export default __webpack_public_path__ + "static/media/CamerronBG.f4cba273.png";